import type { FunctionComponent, ReactNode } from "react";

export type BenefitItem = { icon: ReactNode; title: string; description: string };

export type HomeBenefitsSectionProps = {
  title: string;
  benefits: BenefitItem[];
};

export const HomeBenefitsSection: FunctionComponent<HomeBenefitsSectionProps> = ({
  title,
  benefits,
}) => (
  <section className="container px-5 my-12">
    <h2 className="font-serif text-3xl font-bold mb-8">{title}</h2>
    <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
      {benefits.map((benefit) => (
        <div key={benefit.title} className="flex flex-col gap-2">
          <span className="text-3xl" style={{ color: "var(--color-primary)" }}>
            {benefit.icon}
          </span>
          <h3 className="font-bold">{benefit.title}</h3>
          <p className="text-neutral-600">{benefit.description}</p>
        </div>
      ))}
    </div>
  </section>
);
